import React, { useEffect, useCallback  } from 'react';
import WizardNavigationButton from './WizardNavigationButton';
import { connect } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../store/actions/index';


import Aux from '../../hoc/Aux';

const wizardNavigation = (props) => {

  const dispatch = useDispatch();

  const unsetWizard = useCallback(
      () => dispatch(actions.wizardUnsetStep('country')),
      [dispatch]
    )

  const renderWizardNavigationButton = (stepType, value, i18nTokenType) => {
    let status = "disabled";

    if (value !== '' && value !== undefined && stepType !== props.currentStep ) {
      status="selected"
    } else if (stepType === props.currentStep) {
      status="active"
    }
    return <WizardNavigationButton stepType={stepType} status={status} selectedValue={value} disabledNavigation={props.disabledNavigation} i18nTokenType={i18nTokenType} />
  }

  const selectedSteps = (props.selectedSteps === undefined)? useSelector(state => actions.getWizardObject(state)) : props.selectedSteps;

  useEffect(() => {
    actions.mediumTypeText(selectedSteps['mediumType']);
  }, []);

  return (
    <Aux>
      { renderWizardNavigationButton('country', selectedSteps['country'], 'long') }
      { renderWizardNavigationButton('fwk', selectedSteps['fwk'], 'long') }
      { renderWizardNavigationButton('location', selectedSteps['location'], 'short') }
      { renderWizardNavigationButton('execution_type', selectedSteps['executionType'], 'long') }
      { renderWizardNavigationButton('medium_type', actions.mediumTypeText(selectedSteps['mediumTypes']), 'long') }
      { (props.disabledNavigation !== true && selectedSteps['country'] !== undefined && selectedSteps['country'] !== '' ) ?
      <button onClick={unsetWizard} type="button" className="btn btn-round wizzard-steps-selected" style={{display: "inline-block", marginBottom: "10px", paddingTop: "2px"}}>
        <i className="material-icons" style={{color: "white"}}>replay</i>
      </button> : ""
      }
    </Aux>
  )
};

const mapStateToProps = state => {
  return {
    currentStep: state.wizard.currentStep,
  };
}

const mapDispatchToProps = dispatch => {
  return {

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(wizardNavigation);



// WEBPACK FOOTER //
// ./src/components/Wizard/WizardNavigation.js